<template>
  <div class="container big">
    <div>
      <div class="box">
        <div class="searchbox flex">
          <span>账号</span>
          <el-input
            v-model="user_phone"
            style="width: 160px; margin: 0 20px 0 10px"
            @input="search"
            clearable
          ></el-input>
          <span>姓名</span>
          <el-input
            v-model="real_name"
            style="width: 160px; margin: 0 20px 0 10px"
            @input="search"
            clearable
          ></el-input>

          <el-button
            type="info"
            style="background-color: #eceff2; color: #747981"
            @click="search"
          >查询</el-button>
          <el-button
            type="primary"
            @click="addStaff = true"
            style="margin-left: auto"
          >添加员工</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="账号"
              prop="user_phone"
            ></el-table-column>

            <el-table-column label="姓名">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <div>{{ scope.row.real_name }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="是否医生"
              prop="goods_name"
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.is_doctor"
                  @change="
                    (value) => {
                      return updateDoctor(value, scope.row.admin_id);
                    }
                  "
                  :disabled="scope.row.is_doctor"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column
              label="是否有视频权限"
              prop="goods_name"
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.is_video_inquiry"
                  @change="
                    (value) => {
                      return updateVideo(value, scope.row.admin_id);
                    }
                  "
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <div
                    class="circle"
                    :style="
                      scope.row.status
                        ? 'background:#97d99b'
                        : 'background:#ff514b'
                    "
                  ></div>
                  <div>{{ scope.row.status ? "正常" : "停用" }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="updateStatus(scope.row.admin_id, 1)"
                  v-if="scope.row.status == 0"
                >启用</el-button>

                <el-button
                  type="text"
                  @click="updateStatus(scope.row.admin_id, 0)"
                  class="red"
                  v-if="scope.row.status == 1"
                >禁用</el-button>

                <el-button
                  type="text"
                  class="red"
                  @click="del(scope.row.admin_id)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加员工"
      :visible.sync="addStaff"
      width="500px"
    >
      <div class="content bb">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm myform"
        >
          <el-form-item
            label="员工账号"
            prop="user_phone"
          >
            <el-input
              v-model="ruleForm.user_phone"
              placeholder="请输入员工手机号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="pwd"
          >
            <el-input
              v-model="ruleForm.pwd"
              placeholder="请输入账号密码"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="员工姓名"
            prop="real_name"
          >
            <el-input
              v-model="ruleForm.real_name"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="性别"
            prop="sex"
          >
            <el-radio
              v-model="ruleForm.sex"
              :label="1"
            >男</el-radio>
            <el-radio
              v-model="ruleForm.sex"
              :label="2"
            >女</el-radio>
          </el-form-item>

          <el-form-item
            label="员工编号"
            prop="user_code"
          >
            <el-input v-model="ruleForm.user_code"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="addStaff = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      user_phone: '',
      real_name: '',
      addStaff: false,
      ruleForm: {
        user_phone: '',
        pwd: '',
        real_name: '',
        user_code: '',
        sex: ''
      },
      rules: {
        user_phone: [
          { required: true, message: '请输入员工手机号', trigger: 'blur' },
          {
            pattern: /^(1[3456789])\d{9}$/,
            message: '请输入正确手机号',
            trigger: 'blur'
          }
        ],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        real_name: [
          { required: true, message: '请输入员工姓名', trigger: 'blur' }
        ],
        sex: [{ required: true, message: '请选择员工性别', trigger: 'blur' }]
      }
    };
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_id: this.$route.query.hospital_id,
        user_phone: this.user_phone,
        real_name: this.real_name,
        is_doctor: 0
      };
      this.axios
        .post('platform/clinic/getStaffList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            let list = res.data.list;
            list.forEach((ele) => {
              ele.is_doctor = ele.is_doctor == 1 ? true : false;
            });
            list.forEach((ele) => {
              ele.is_video_inquiry = ele.is_video_inquiry == 1 ? true : false;
            });
            this.tableData = list;
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelect(key) {
      this.hospital_name = '';
      this.goods_name = '';
      this.dosage_form = '';
      this.active = key;
      this.currentPage = 1;
      this.pagesize = 10;
      this.getList();
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    submitForm(formName) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            user_phone: this.ruleForm.user_phone,
            real_name: this.ruleForm.real_name,
            user_code: this.ruleForm.user_code,
            sex: this.ruleForm.sex,
            pwd: this.ruleForm.pwd,
            hospital_id: this.$route.query.hospital_id,
            group_id: '3'
          };
          this.axios.post('platform/clinic/addStaffInfo', data).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功');
              this.getList();
              this.addStaff = false;
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //视频权限开启/关闭
    updateVideo(value, admin_id) {
      let inquiry = value ? 1 : 0;
      this.$confirm('确定更改当前用户视频权限吗', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/clinic/editStaffVideoInquiry', {
              admin_id,
              inquiry,
              hospital_id: this.$route.query.hospital_id
            })
            .then((res) => {
              this.getList();
            })
            .catch((err) => {
              this.getList();
              console.log(err);
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    //医生权限开启/关闭
    updateDoctor(value, admin_id) {
      let doctor = value ? 1 : 0;
      this.$confirm('确定更改当前用户医生权限吗', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/clinic/editStaffDoctor', {
              admin_id,
              doctor
            })
            .then((res) => {
              this.getList();
            })
            .catch((err) => {
              this.getList();
              console.log(err);
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    //禁用启用
    updateStatus(admin_id, status) {
      let data = {
        hospital_id: this.$route.query.hospital_id,
        admin_id,
        status
      };
      this.axios.post('platform/clinic/editStaffStatus', data).then((res) => {
        this.getList();
      });
    },
    del(admin_id) {
      this.$confirm('确定要删除员工吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            admin_id,
            hospital_id: this.$route.query.hospital_id
          };
          return this.axios.post('platform/clinic/delStaff', data);
        })
        .then(() => {
          this.getList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.yaoshi {
  width: 44px;
  height: 21px;
  background-color: #669961;
  border-radius: 11px;
  text-align: center;
  color: #fff;
  display: inline-block;
  margin-left: 8px;
}
.el-dialog__body .content {
  padding: 15px;
  text-align: left;
}
.myform {
  padding: 0 30px 0 10px;
}
</style>
